import { IconButton, Tooltip } from '@mui/material';
import React, { FC, ReactNode } from 'react';

const RightIconButton: FC<{ icon: ReactNode; onClick: () => void; tooltipTitle?: string }> = ({
	icon,
	onClick,
	tooltipTitle,
}) => {
	return (
		<>
			<Tooltip title={tooltipTitle} placement="top" arrow>
				<IconButton
					onClick={() => onClick()}
					sx={{
						backgroundColor: 'primary.main',
						color: '#fff',
						'&:hover': {
							backgroundColor: 'primary.main',
						},
					}}
				>
					{icon}
				</IconButton>
			</Tooltip>
		</>
	);
};
export default RightIconButton;
